export interface StarHalfFillProps {
  idPrefix: string | number
}
export const StarHalfFill = ({ idPrefix }: StarHalfFillProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="half-filled-star"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 18.3507L17.4258 21.2214L16.3888 15.139L20.7908 10.8212L14.7092 9.93179L12 4.40688L9.29076 9.93179L3.20914 10.8212L7.61115 15.139L6.57422 21.2214L12 18.3507ZM6.00062 15.6604L4.92494 21.9701C4.78553 22.7879 5.64511 23.41 6.37839 23.022L12 20.0477L17.6216 23.022C18.3549 23.41 19.2144 22.7879 19.075 21.9701L17.9994 15.6604L22.5608 11.1863C23.1512 10.6072 22.8235 9.60257 22.0053 9.4829L15.7081 8.56193L12.8978 2.83096C12.5319 2.08467 11.4681 2.08467 11.1021 2.83096L8.29186 8.56193L1.99471 9.4829C1.17645 9.60257 0.848808 10.6072 1.43919 11.1863L6.00062 15.6604Z"
      fill="#5234B6"
    />

    <mask
      id={`${idPrefix}-half-fill-mask`}
      x="0"
      y="0"
      width="12"
      height="24"
      fill="white"
    >
      <rect x="0" y="0" width="12" height="24" />
    </mask>
    <path
      d="M12 18.3507L17.4258 21.2214L16.3888 15.139L20.7908 10.8212L14.7092 9.93179L12 4.40688L9.29076 9.93179L3.20914 10.8212L7.61115 15.139L6.57422 21.2214L12 18.3507ZM6.00062 15.6604L4.92494 21.9701C4.78553 22.7879 5.64511 23.41 6.37839 23.022L12 20.0477L17.6216 23.022C18.3549 23.41 19.2144 22.7879 19.075 21.9701L17.9994 15.6604L22.5608 11.1863C23.1512 10.6072 22.8235 9.60257 22.0053 9.4829L15.7081 8.56193L12.8978 2.83096C12.5319 2.08467 11.4681 2.08467 11.1021 2.83096L8.29186 8.56193L1.99471 9.4829C1.17645 9.60257 0.848808 10.6072 1.43919 11.1863L6.00062 15.6604Z"
      fill="#5234B6"
      mask={`url(#${idPrefix}-half-fill-mask)`}
    />
  </svg>
)
